<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="text-center">Impressão de Atividades</h1>
      <div v-if="!loadingAtividades">
        <button @click="print()" class="btn btn-success btn-sm ml-4" v-if="AtividadesList.length > 0">Imprimir</button>
        <button class="btn btn-default" @click="voltar()">Voltar</button>
      </div>
    </div>
    <load v-if="loadingAtividades" message="Carregando Atividades" />
    <div v-else-if="showErrorMessage" class="text-center py-5">
      <div class="alert alert-warning" role="alert">
        <i class="fas fa-exclamation-triangle fa-2x mb-3"></i>
        <h4>{{ errorTitle }}</h4>
        <p>{{ errorMessage }}</p>
        <button class="btn btn-primary mt-2" @click="voltar()">
          <i class="fas fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
    <div v-else id="boxPrint" class="col-12 px-0">
      <print-content>
        <h2 class="text-center">Atividades</h2>
        <br>
        <table
          v-for="item in AtividadesList"
          :key="item.id"
          class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
        >
          <tbody>
            <tr>
              <td colspan="2">
                ID: <strong>{{ item.id }}</strong>
              </td>
              <td colspan="2">
                PROTOCOLO: <strong>{{ item.protocolo }}</strong>
              </td>
            </tr>
            <tr v-if="item.tema">
              <td colspan="4">
                TEMA: <strong>{{ item.tema }}</strong>
              </td>
            </tr>
            <tr v-if="item.titulo">
              <td colspan="4">
                TÍTULO: <strong>{{ item.titulo }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                TIPO: <strong>{{ item.tipo }}</strong>
              </td>
              <td colspan="2">
                SERVIÇO: <strong>{{ item.servico_tipo || 'N/A' }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                DATA: <strong>{{ item.data | formatDate() }}</strong>
              </td>
              <td>
                HORA: <strong>{{ item.hora || 'N/A' }}</strong>
              </td>
              <td colspan="2">
                DURAÇÃO: <strong>{{ item.duracao || 'N/A' }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                RESPONSÁVEL: <strong>{{ item.responsavel || 'N/A' }}</strong>
              </td>
            </tr>
            <tr v-if="item.local">
              <td colspan="4">
                LOCAL DA ATIVIDADE: <strong>{{ item.local }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                STATUS: <strong v-html="item.status_nome"></strong>
              </td>
              <td colspan="2">
                SIGILO: <strong>{{ item.privado ? 'Sim' : 'Não' }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </print-content>

      <div class="row align-items-center no-print">
        <div class="col-lg-6 col-md-12">
          <div class="form-group d-inline-flex mb-0">
            <select
              class="form-control"
              style="width: 70px"
              v-model="perPage"
              v-on:change="gerarImpressao"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="30">30</option>
            </select>
          </div>
          <div class="d-inline-flex ml-2">
            <b-pagination
              :per-page="perPage"
              :total-rows="pagination.total"
              @change="changePage"
              v-model="page"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
          <div class="float-lg-right">
            {{ $t("Showing page") }}
            {{ pagination.currentPage }}
            de
            {{ pagination.totalPages }}
            {{ $t("pages in") }}
            {{ pagination.total }}
            {{ $t("records") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpressaoAtividades',
  props: {
    morph: {
      type: Object,
      default: null
    },
    filtroResp: {
      type: Number,
      default: null
    },
    filtroTipo: {
      type: [Number, Array],
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    filtroDatas: {
      type: Array,
      default: () => []
    },
    filtroStatus: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loadingAtividades: true,
      AtividadesList: [],
      showErrorMessage: false,
      errorTitle: '',
      errorMessage: '',
      page: 1,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      perPage: 10,
    }
  },
  mounted() {
    this.gerarImpressao();
  },
  methods: {
    gerarImpressao() {
      this.loadingAtividades = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        search: this.search,
      }

      if (this.morph && this.morph.id && this.morph.type) {
        params.morph_id = this.morph.id;
        params.morph_type = this.morph.type;
      }

      if (this.filtroResp) {
        params.filtroResp = this.filtroResp;
      }

      if (this.filtroTipo) {
        params.filtroTipos = this.filtroTipo;
      }

      if (this.filtroDatas && this.filtroDatas.length > 0) {
        params.filtroDatas = this.filtroDatas;
      }

      if (this.filtroStatus && this.filtroStatus.length > 0) {
        params.filtroStatus = this.filtroStatus;
      }
      
      axios
        .get("api/dashboard/atividades/imprimir", {
          params: params,
        })
        .then((response) => {
          this.loadingAtividades = false;

          if (response.data && response.data.data && response.data.data.length > 0) {
            this.AtividadesList = response.data.data;
          } else {
            this.AtividadesList = [];
          }

          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.gerarImpressao();
          } else {
            this.loadingAtividades = false;
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar atividades para impressão", error);
          this.loadingAtividades = false;
          this.showErrorMessage = true;

          if (error.response) {
            switch (error.response.status) {
              case 401:
                this.errorTitle = 'Acesso Negado';
                this.errorMessage = 'Você não tem permissão para visualizar estas atividades.';
                break;
              case 403:
                this.errorTitle = 'Permissão Insuficiente';
                this.errorMessage = 'Você não possui as permissões necessárias para acessar este recurso.';
                break;
              case 404:
                this.errorTitle = 'Não Encontrado';
                this.errorMessage = 'As atividades solicitadas não foram encontradas.';
                break;
              case 500:
                this.errorTitle = 'Erro do Servidor';
                this.errorMessage = 'Ocorreu um erro interno. Tente novamente em alguns instantes.';
                break;
              default:
                this.errorTitle = 'Erro ao Carregar';
                this.errorMessage = error.response.data?.message || 'Não foi possível carregar as atividades.';
            }
          } else if (error.request) {
            this.errorTitle = 'Erro de Conexão';
            this.errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
          } else {
            this.errorTitle = 'Erro Inesperado';
            this.errorMessage = 'Ocorreu um erro inesperado. Tente novamente.';
          }
        });
    },
    voltar() {
      this.$emit('voltar');
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.gerarImpressao();
      }
    },
  }
}
</script>
